import React, { useCallback, useEffect, useMemo, useState } from "react";

import { Accordion, Card, Row, Col } from "react-bootstrap";
import { MdKeyboardArrowRight } from "react-icons/md";
import { BsArrowLeft, BsArrowRight } from "react-icons/bs";

import toastr from "toastr";

import { initialForm } from "./CONSTANTS";
import { getCapaOwner } from "app/_services/ehs/ehsCapaOwner";
import { capaStatuses, commentTypes } from "../IncidentManagement/CONSTANTS";
import { Validation } from "app/_helpers/validation/Validation";
import { formatDDMMYYYYbyYYYYMMDD, userDropdownLabel } from "app/_helpers/helper";
import { UserService } from "app/_services/UserService/UserService";
import { approveRejectCapa } from "app/_services/ehs/ehsCapaServices";
import { getVFLByID, updateVFLCapa } from "app/_services/ehs/VFLService";
import { CommmonService } from "app/_services/CommonService/CommonService";
import { DepartmentService } from "app/_services/UserManagement/DepartmentService";
import { getAllAreaOfOperation } from "app/_services/ehs/ehsAreaOfOperationServices";

import VFLDetailsInfo from "./component/VFLDetailsInfo";
import VFLTimeline from "./component/VFLTimeline";
import Capas from "../Capas";
import IncidentComments from "../IncidentManagement/IncidentComments";
import { OBSERVATION_CATEGORY } from "./component/ObservationTab";
import ViewComments from "../IncidentManagement/ViewComments";
import MainBreadcrumb from "app/views/custom/components/MainBreadcrumb";

const rules = [
  {
    field_name: "reviewCompletionSummary",
    label: "Summary",
    type: "string",
    isRequired: true,
  },
];

const VFLSOForm = ({
  match: {
    params: { id: incidentDetailsId = null },
  },
  history,
}) => {
  const [tab, setTab] = useState(+CommmonService.getQueryParam("tab") || 1);
  const [form, setForm] = useState({
    reviewCompletionSummary: "",
    id: incidentDetailsId,
  });
  const [errorForm, setErrorForm] = useState({
    ...initialForm,
  });
  const [users, setUsers] = useState([]);
  const [departments, setDepartments] = useState([]);

  const [comments, setComments] = useState([]);

  /*************Tab State *********/
  const [observation, setObservation] = useState([]);

  const [saving, setSaving] = useState(false);

  const [area, setArea] = useState([]);
  const [capaOwners, setCapaOwners] = useState([]);

  /********* Capa State *********/
  const [capas, setCapas] = useState([]);

  const setFormDataById = useCallback(() => {
    if (!incidentDetailsId) return false;

    getVFLByID(incidentDetailsId).then((response) => {
      if (!response?.status) {
        history.push("/health-safety-and-environment/vfl");
        toastr.error(response?.message || "Something went Wrong");
        return;
      }
      if (!response?.data) return;

      setForm({
        ...(response?.data || {}),
        reviewCompletionSummary: "",
      });
      setObservation(response.data.vflObservations || []);
      setComments(response?.data?.incidentReviewsData);
      let obj = {};
      for (const iterator of response.data.vflObservations) {
        obj[iterator.id] = iterator.allCapa;
      }
      setCapas(obj || {});
    });
  }, [incidentDetailsId]);

  /**************** Form Method ************************/
  const onChange = ({ target: { name, type, value, checked } }) => {
    setForm((prevForm) => {
      const newForm = {
        ...prevForm,
        [name]: type === "checkbox" ? checked : value,
      };

      return newForm;
    });
  };

  /********* CapaTab *********/
  const approveCapa = useCallback(
    (index, capaId, obj, id) => {
      approveRejectCapa(capaId, obj).then((response) => {
        if (response?.status) {
          setFormDataById();
        }
      });
    },
    [setFormDataById]
  );

  /********* onSubmit *********/
  const onSubmit = useCallback(
    async (validate, dontGoBack = false, moveReport = "stay") => {
      if (saving) return;
      setSaving(true);
      const toast = toastr.warning("Saving, please wait...");
      let flag = 0;

      const errorObj = Validation(form, rules);

      if (form.capaRequired && !capas.filter((d) => !d.deleted).length)
        errorObj.capaRequired = "Minimum one row of CAPAs is required!";

      setErrorForm(validate ? errorObj : {});

      if (validate) {
        for (const key in errorObj)
          if (errorObj[key]) {
            flag = 1;
            break;
          }
      }

      if (flag !== 0) {
        toastr.clear(toast);
        toastr.warning("Form inputs missing. Please complete all sections.");
        setSaving(false);
        return;
      }

      const response = await updateVFLCapa(form.id, {
        moveReport,
        reviewCompletionSummary: form?.reviewCompletionSummary,
        isBack: 0,
      });

      toastr.clear(toast);

      if (!response?.status) {
        setSaving(false);
        return toastr.error(response?.message);
      }
      if (dontGoBack) setTab((prev) => prev + 1);

      toastr.success(response.message || "Success.");

      setSaving(false);

      if (!dontGoBack) history.push("/health-safety-and-environment/vfl/manage");
    },
    [capas, form, history, saving]
  );

  /************ useEffect*********/
  useEffect(() => {
    if (+tab > 0) CommmonService.updateQueryParam("tab", tab);
  }, [tab]);

  useEffect(() => {
    UserService.getUsers("filter[status]=1").then((response) => {
      if (!response?.data) return;

      setUsers(response.data);
    });
    DepartmentService.getDepartment().then((response) => {
      if (!response?.data) return;

      setDepartments(response.data.departments);
    });
    getAllAreaOfOperation().then((response) => {
      if (!response?.data) return;
      setArea(response.data);
    });

    getCapaOwner().then((response) => {
      if (!response?.data) return;
      setCapaOwners(response.data.capaOwners);
    });
  }, []);

  useEffect(() => {
    setFormDataById();
  }, [setFormDataById]);

  const sentFlag = useMemo(() => {
    let flag = true;
    for (const iterator of observation) {
      if (Array.isArray(iterator?.allCapa)) {
        if (iterator?.allCapa?.find((d) => d.capaStatus === capaStatuses.open)) {
          flag = false;
        }
      }
    }
    console.log("observation", observation);

    console.log("qqqqqqqqqsentFlag", flag);

    return flag;
  }, [observation]);

  const sentBackFlag = useMemo(() => {
    let flag = false;
    for (const iterator of observation) {
      if (Array.isArray(iterator?.allCapa)) {
        if (iterator?.allCapa?.find((d) => d.capaStatus === capaStatuses.open)) {
          flag = true;
        }
      }
    }

    return flag;
  }, [observation]);

  console.log("sentFlag", sentFlag);

  return (
    <>
      <MainBreadcrumb
        routeSegments={[
          { name: "Health Safety And Environment", path: "#" },
          {
            name: "VFL",
            path: "/health-safety-and-environment/vfl",
          },
          { name: "View VFL" },
        ]}
      />

      <div className="p-1">
        <div className="simple-card-title cardCustomHeader justify-content-between">
          {/* <h3 className="text-capitalize mb-0">View VFL</h3> */}

          {/* <BackBtn url={"/health-safety-and-environment/vfl"} /> */}
        </div>
        <div className="healthSafetyEnvironmentWrapper">
          <div className="healthSafetyEnvironmentWrapper incidentMenu">
            <div className="hseMenuLinks card pointer" style={{ minHeight: 75 }}>
              <a className={`${tab === 1 ? "active" : ""}`} onClick={() => setTab(1)}>
                Timeline
              </a>

              <a className={`${tab === 2 ? "active" : ""}`} onClick={() => setTab(2)}>
                CAPA
              </a>
              <a className={`${tab === 3 ? "active" : ""}`} onClick={() => setTab(3)}>
                Safety Officer Input
              </a>
            </div>
          </div>
        </div>
        <Row>
          <Col lg={9} className="pt-4">
            {tab === 1 && <VFLTimeline form={form} />}
            {tab === 3 && (
              <div className="card p-3 pb-0">
                <div className="simple-card-title mb-0">
                  <h3 className="text-capitalize mb-0">Investigation</h3>
                </div>
                <div className="ehsFormWrapper p-0">
                  <Row>
                    <Col lg={8} className="reviewerInputsComments pt-2">
                      {form.isBack === 1 && (
                        <p style={{ color: "red" }}>
                          {form?.backData?.length > 0 &&
                            form?.backData[form.backData.length - 1]?.comment}
                        </p>
                      )}
                      <ViewComments comments={comments} viewOnly />
                      <div className="addReviewerInput">
                        <textarea
                          class="form-control"
                          style={{ height: "88px" }}
                          name="reviewCompletionSummary"
                          onChange={onChange}
                          value={form.reviewCompletionSummary}
                          maxLength={500}
                          placeholder={"Summary (max 500 characters)"}
                        />
                        <span className="small text-danger">
                          {errorForm.reviewCompletionSummary}
                        </span>
                      </div>
                    </Col>
                    <Col lg={4}>
                      <div className="timelineText mmInputScreen  mt-1">
                        <ul className="list-inline d-flex">
                          <li className="secInfo">
                            <div className="timelineRow py-1">
                              <h5 className="txtgrey mb-1">VFL Schedule Date</h5>
                              <h5 className="mb-1">
                                {formatDDMMYYYYbyYYYYMMDD(form?.vflScheduledDateTime)}
                              </h5>
                            </div>
                            <div className="timelineRow py-1">
                              <h5 className="txtgrey mb-1">VFL Scheduled by</h5>
                              <h5 className="mb-1">
                                {userDropdownLabel(form?.schedularData)}
                              </h5>
                            </div>
                            <div className="timelineRow py-1">
                              <h5 className="txtgrey mb-1">VFL Executed on</h5>
                              <h5 className="mb-1">
                                {formatDDMMYYYYbyYYYYMMDD(form?.vflCompletionDateTime)}
                              </h5>
                            </div>
                            <div className="timelineRow py-1">
                              <h5 className="txtgrey mb-1">VFL Executed by</h5>
                              <h5 className="mb-1">
                                {userDropdownLabel(form?.vflOfficerData)}
                              </h5>
                            </div>
                            <div className="timelineRow py-1">
                              <h5 className="txtgrey mb-1">VFL Completed on</h5>
                              <h5 className="mb-1">
                                {formatDDMMYYYYbyYYYYMMDD(form?.vflCompletionDateTime)}
                              </h5>
                            </div>
                          </li>
                        </ul>
                      </div>
                    </Col>
                  </Row>
                  <ButtonsContainer
                    sentBackFlag={sentBackFlag}
                    onSubmit={onSubmit}
                    lastTab={13}
                    tab={tab}
                    setTab={setTab}
                    noNext={sentFlag}
                  />
                </div>
              </div>
            )}
            {tab === 2 && (
              <div className="card p-3 pb-0">
                <div className="simple-card-title">
                  <h3 className="text-capitalize mb-0">Add CAPA</h3>
                </div>
                <div className="ehsFormWrapper">
                  {observation
                    .filter((d) => !["safeCondition", "safeAct"].includes(d.type))
                    .map((observationObj) => {
                      return (
                        <div className="capaSections" key={observationObj.id}>
                          <h3>
                            {
                              OBSERVATION_CATEGORY.find(
                                (data) => data.id === observationObj.type
                              )?.label
                            }
                          </h3>
                          <Capas
                            capas={capas[observationObj.id]}
                            users={users}
                            departments={departments}
                            area={area}
                            capaowner={capaOwners}
                            incidentsOnly
                            viewOnly
                            approveCapa={(index, capaId, obj) =>
                              approveCapa(index, capaId, obj, observationObj.id)
                            }
                            approverLevel={"so"}
                            showReject
                          />
                        </div>
                      );
                    })}
                </div>
                <ButtonsContainer
                  sentBackFlag={sentBackFlag}
                  onSubmit={onSubmit}
                  lastTab={3}
                  tab={tab}
                  setTab={setTab}
                />
              </div>
            )}

            <div className="mt-4 text-center">
              <span className="btn btn-secondary mx-2" onClick={history.goBack}>
                Go Back
              </span>
            </div>
          </Col>

          <Col lg={3}>
            <div className="mt-4">
              <h5>You are editing as an SO Officer.</h5>

              <Accordion>
                <div className="mb-3">
                  <Accordion.Toggle
                    as={Card.Header}
                    eventKey="10"
                    className="rightIncidentCard p-0"
                  >
                    <div className="rightInfoTitle">
                      VFL
                      <MdKeyboardArrowRight />
                    </div>
                  </Accordion.Toggle>

                  <Accordion.Collapse eventKey="10">
                    <Card.Body className="p-0">
                      <VFLDetailsInfo form={form} />
                    </Card.Body>
                  </Accordion.Collapse>
                </div>
              </Accordion>
            </div>
          </Col>
        </Row>
      </div>
    </>
  );
};

const ButtonsContainer = ({ sentBackFlag, tab, setTab, lastTab, onSubmit, noNext }) => (
  <div className="stepperFormButtons">
    {tab > 1 && (
      <span className="pointer btn btn-left" onClick={() => setTab((prev) => prev - 1)}>
        <BsArrowLeft /> Back
      </span>
    )}

    {sentBackFlag && (
      <span
        className="pointer btn btn-right"
        onClick={() => onSubmit(false, false, "backward")}
      >
        Send back to Area Owner
      </span>
    )}

    {!noNext && tab < lastTab ? (
      <span
        className="pointer btn btn-right"
        onClick={() => {
          // onSubmit(false, true, "stay");
          setTab((prev) => prev + 1);
        }}
      >
        Next
        <BsArrowRight />
      </span>
    ) : (
      <span
        className="pointer btn btn-right"
        onClick={() => onSubmit(false, false, "stay")}
      >
        Save
      </span>
    )}
    {noNext && (
      <span
        className="pointer btn btn-right"
        onClick={() => onSubmit(true, false, "forward")}
      >
        Submit for Mines Manager Review
      </span>
    )}
  </div>
);

export default VFLSOForm;
